import keytechLogo from "../../../assets/storymap/port-gallery/KeyTechLabLogo.png";
import highlineLogo from "../../../assets/storymap/port-gallery/highline-college.png";
import worldReliefLogo from "../../../assets/storymap/port-gallery/worldRelief.jpg";
import keytechBanner from "../../../assets/storymap/port-gallery/keytech-banner.jpg";
import highlineBanner from "../../../assets/storymap/port-gallery/highline-banner.png";
import worldReliefBanner from "../../../assets/storymap/port-gallery/wr-banner.jpg";
import lcaLogo from "../../../assets/storymap/port-gallery/lcaLogo.png";
import lcaBanner from "../../../assets/storymap/port-gallery/lca-banner.jpg";

// Keytech gallery
const img1 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/IMG_0839.jpg";
const img2 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/IMG_0841.jpg";
const img3 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/IMG_0843.jpg";
const img4 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/IMG_0846.jpg";
const img5 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/IMG_0859.jpg";
const img6 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/IMG_0864.jpg";
const img7 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/IMG_0877.jpg";
const img8 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/IMG_0887.jpg";
const img9 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/IMG_0904.jpg";
const img10 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/keytech1.jpg";
const img11 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/keytech2.jpg";
const img12 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/keytech3.jpg";
const img13 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/keytech4.jpg";
const img14 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/keytech5.jpg";
const img15 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/keytech6.jpg";
const img16 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/keytech7.jpg";
const img17 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/keytech8.jpg";

// Latino Civic Alliance
const img18 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/BFIL Photos.jpg";
const img19 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/DSC02635-Enhanced-NR.jpg";
const img20 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/LCA BFIL MI Grad Photos.jpg";
const img21 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/LCA BFIL Photos 2.jpg";
const img22 = "https://port-storymap-content.s3.us-west-2.amazonaws.com/LCA BFIL Photos.jpg";

export interface SKPCFPartners {
    src: string;
    alt: string;
    color: string;
    title: string;
    subtitle: string;
    description: string[];
    shortDescription: string;
    focus: string;
    industry: string;
    banner: string;
    website: string;
    video: string;
    images?: string[];
    funding: {
        value: number;
        dates: string;
        participants: number;
    };
    participantData: {
        demographics?: ParticipantData[];
        gender?: ParticipantData[];
        highlights?: ParticipantHighlight[];
    };
    item: {
        id: number;
        lat: number;
        long: number;
    }
};

export type ParticipantData = {
    label: string;
    value: number;
};

export type ParticipantHighlight = {
    value: string;
    label: string;
    detail?: string;
};

export const partners: SKPCFPartners[] = [
    { 
        src: keytechLogo, 
        alt: "Key Tech Labs", 
        color: "#c54200", 
        title: "Key Tech Labs", 
        subtitle: "SharkGarden, a community garden in Burien.", 
        description: ["Key Tech Labs brings green technology to communities who otherwise would not have the opportunity. BIPOC youth and young adults are exposed to and prepared for employment in green jobs through a hybrid learning environment.", "Students complete hands-on internship projects to support the ecosystem of SharkGarden, a local community garden which produces its own energy and captures its own stormwater to nourish plants and grow food for the community. The internship includes maintenance, installation, and upkeep of solar panels and other green construction projects. Social-emotional skills are also a priority through Restorative Justice Circles where students learn to navigate challenges they may face in green job work environments."], 
        shortDescription: "brings green technology to communities who otherwise would not have the opportunity.",
        focus: "Training",
        industry: "Green Jobs",
        banner: keytechBanner, 
        website: "https://www.facebook.com/Keytechlabs", 
        video: "https://www.youtube.com/watch?v=fnqctMfo0f4",
        images: [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15, img16, img17],
        funding: {
            value: 246864,
            dates: '2022 - 2025',
            participants: 37
        },
        participantData: {
            demographics: [
                { label: "African American", value: 17 },
                { label: "Latino", value: 8 },
                { label: "White", value: 4 },
                { label: "Asian", value: 2 },
                { label: "Middle Eastern", value: 1 },
                { label: "Native American", value: 1 },
                { label: "Pacific Islander", value: 1 },
                { label: "Other", value: 3 },
            ],
            gender: [
                { label: "Female", value: 14},
                { label: "Male", value: 21}
            ],
            highlights: [
                {
                    value: "33",
                    label: "Participants in paid internships.",
                },
            ]
        },
        item: {
            id: 193,
            lat: 47.44609,
            long: -122.34605,
        }
    },
    { 
        src: highlineLogo, 
        alt: "Puget Sound Welcome Back Center", 
        color: "#f7d383", 
        title: "Puget Sound Welcome Back Center", 
        subtitle: "Our college. Our community. Our future.", 
        description: ["The Puget Sound Welcome Back Center, fiscally sponsored by the Highline College Foundation, supports immigrants and refugees with international degrees and training to re-enter the local workforce. In King County, a quarter of residents are foreign-born and Washington is one of the top five refugee-receiving states in the US. The Welcome Back Center provides support in relicensing, case management, vocational language assistance, and finding jobs in construction trades and pre-apprenticeship programs."], 
        shortDescription: "supports immigrants and refugees with international degrees and training to re-enter the local workforce.",
        focus: "Career Navigation",
        industry: "Construction",
        banner: highlineBanner,
        website: "https://welcomeback.highline.edu/",
        video: "https://www.youtube.com/watch?v=FumDjx8xrYQ&feature=youtu.be",
        images: [highlineBanner],
        funding: {
            value: 238621,
            dates: '2024 - 2026',
            participants: 56
        },
        participantData: {
            demographics: [
                { label: "African American", value: 4 },
                { label: "Latino", value: 0 },
                { label: "White", value: 5 },
                { label: "Asian", value: 47 },
                { label: "Middle Eastern", value: 0 },
                { label: "Native American", value: 0 },
                { label: "Pacific Islander", value: 0 },
                { label: "Other", value: 0 },
            ],
            gender: [
                { label: "Female", value: 1},
                { label: "Male", value: 55}
            ],
            highlights: [
                {
                    value: "26",
                    label: "Participants with transcript and credential approval by National Council of Examiners for Engineering and Surveying (NCEES)",
                },
                {
                    value: "34",
                    label: "Participants registered for Fundamentals of Engineering",
                },
                {
                    value: "10",
                    label: "Participants enrolled into pre-apprenticeship programs",
                },
                {
                    value: "9",
                    label: "Participants placed into construction trade jobs",
                    detail: "Wages ranging from $32-45 per hour"
                }
            ]
        },
        item: {
            id: 214,
            lat: 47.38842,
            long: -122.305145,
        }
    },
    { 
        src: worldReliefLogo, 
        alt: "World Relief Seattle", 
        color: "#bcd7c1", 
        title: "World Relief Seattle", 
        subtitle: "A community of welcome in western Washington.", 
        description: ["World Relief Seattle works to strengthen the local economy by helping refugees and immigrants find higher-paying jobs at SEA (Seattle-Tacoma International Airport). Bilingual staff provide workshops, employment navigation, resume and interview prep, work-related support services and job placement with SEA employers that offer higher-wage jobs. World Relief trains employers on how to support newly arrived refugees in the workplace."], 
        shortDescription: "works to strengthen the local economy by helping refugees and immigrants find higher-paying jobs at SEA (Seattle-Tacoma International Airport).",
        focus: "Career Navigation",
        industry: "Aviation",
        banner: worldReliefBanner,
        website: "https://worldrelief.org/western-wa/",
        video: "https://www.youtube.com/watch?v=M30_sEvOpZg",
        images: [worldReliefBanner],
        funding: {
            value: 249870,
            dates: '2022 - 2025',
            participants: 243
        },
        participantData: {
            demographics: [
                { label: "African American", value: 109 },
                { label: "Latino", value: 16 },
                { label: "White", value: 18 },
                { label: "Asian", value: 155 },
                { label: "Middle Eastern", value: 7 },
                { label: "Native American", value: 1 },
                { label: "Pacific Islander", value: 0 },
                { label: "Other", value: 0 },
            ],
            gender: [
                { label: "Female", value: 28},
                { label: "Male", value: 212}
            ],
            highlights: [
                {
                    value: "133",
                    label: "Participants placed into jobs at SEA",
                    detail: "Wages ranging from $19-$24 per hour",
                },
                {
                    value: "118",
                    label: "Participants retained employment over time",
                }
            ]
        },
        item: {
            id: 183,
            lat: 47.3807,
            long: -122.23741,
        }
    },
    { 
        src: lcaLogo, 
        alt: "Latino Civic Alliance", 
        color: "#6f8fa6", 
        title: "Latino Civic Alliance", 
        subtitle: "There is no Washington without latinos.", 
        description: ["The Latino Civic Alliance's Building Future Industry Leaders program provides specialized training and employment navigation to Spanish-speaking communities to enter careers in Port-related industries such as aviation, construction trades, green jobs, and maritime jobs. The program reduces barriers by partnering directly with contractors, unions, and employers to ensure students who graduate from the program meet the industry standard requirements."], 
        shortDescription: "provides specialized training and employment navigation to Spanish-speaking communities to enter careers in Port-related industries.",
        focus: "Career Navigation",
        industry: "Aviation, Construction Trades, Green Jobs and Maritime",
        banner: lcaBanner,
        website: "https://latinocivicalliance.org/",
        video: "https://www.youtube.com/watch?v=15nElXTGL7s",
        images: [img18, img19, img20, img21, img22],
        funding: {
            value: 250000,
            dates: '2022 - 2024',
            participants: 270
        },
        participantData: {
            demographics: [
                { label: "African American", value: 3 },
                { label: "Latino", value: 263 },
                { label: "White", value: 0 },
                { label: "Asian", value: 0 },
                { label: "Middle Eastern", value: 1 },
                { label: "Native American", value: 0 },
                { label: "Pacific Islander", value: 3 },
                { label: "Other", value: 0 },
            ],
            gender: [
                { label: "Female", value: 83},
                { label: "Male", value: 104}
            ],
            highlights: [
                {
                    value: "32",
                    label: "Participants placed in pre-apprenticeships",
                },
                {
                    value: "28",
                    label: "Participants placed into apprenticeships",
                },
                {
                    value: "37",
                    label: "Participants placed into jobs",
                    detail: "Wages ranging from $45k-$65k",
                }
            ]
        },
        item: {
            id: 197,
            lat: 47.46864,
            long: -122.33942,
        }
    },
];

